import {
  MERCHANT_FETCH,
  MERCHANT_FETCH_SUCCESS,
  MERCHANT_FETCH_FAIL,
  CHANGE_SELECT_MERCHANT,
  CLEAR_FILTER_ALL,
  MERCHANT_SUMMARY_FETCH,
  MERCHANT_SUMMARY_FETCH_SUCCESS,
  MERCHANT_SUMMARY_FETCH_FAIL
} from '../actions';

const INIT_STATE = {
    merchant: [],
    loading: false,
    error: '',
    merchantId: '',
    merchantSummary: 0
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MERCHANT_FETCH:
            return { ...state, loading: true, error: ''};
        case MERCHANT_FETCH_SUCCESS:
            return { ...state, loading: false, merchant: action.payload, error: ''};
        case MERCHANT_FETCH_FAIL:
            return { ...state, loading: false, merchant: [], error: action.payload.message, totalAmount: 0 };

        case CHANGE_SELECT_MERCHANT:
            return { ...state, merchantId: action.payload };
        case CLEAR_FILTER_ALL:
            return { ...state, merchantId: ''};

        case MERCHANT_SUMMARY_FETCH:
            return { ...state, loading: true, error: ''};
        case MERCHANT_SUMMARY_FETCH_SUCCESS:
            return { ...state, loading: false, merchantSummary: action.payload.merchantSummary, error: ''};
        case MERCHANT_SUMMARY_FETCH_FAIL:
            return { ...state, loading: false, merchantSummary: 0, error: action.payload.message, totalAmount: 0 };

        default: return { ...state };
    }
}
